
import { MapPin } from "lucide-react";

interface PropertyLocationDisplayProps {
  address: string;
  city: string;
  state: string;
  zipCode: string;
}

export const PropertyLocationDisplay = ({
  address,
  city,
  state,
  zipCode
}: PropertyLocationDisplayProps) => {
  return (
    <div className="flex items-start space-x-2">
      <MapPin className="h-5 w-5 text-godyspo-gold mt-0.5" />
      <div>
        <h2 className="text-xl font-medium">{address}</h2>
        <p className="text-muted-foreground">
          {city}, {state} {zipCode}
        </p>
      </div>
    </div>
  );
};
